import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { FormProvider } from './FormProvider';
import useFormField from './useFormField';

interface IProps {
  name: string;
}

export default function FormFieldError({ name }: IProps) {
  const { hasError, error } = useFormField(name);
  const { t } = useTranslation();
  const { validationNamespace } = useContext(FormProvider);

  if (!hasError) return null;

  let errorMessage;

  if (typeof error === 'string') {
    const [scope, errorKey] =
      error && error.split('/').length > 1 ? error.split('/') : [validationNamespace, error];
    errorMessage = t(`${scope}.error`, { context: errorKey });
  } else {
    errorMessage = t(`${validationNamespace}.error`, { context: error.key, ...error.params });
  }

  return (
    <div data-testid="field-error" className="novoFormFieldError">
      {errorMessage}
    </div>
  );
}
